import { fetchLectors } from "@/api/lectors";
import { API_URL } from "@/api/apiRequest";

export async function loadLectors({ state }) {
  const response = await fetchLectors();
  state.lectors = response.map(lector => {
    return { ...lector, img: `${API_URL}/${lector.img}` };
  });
}
